/**
 * A light look at a chosen file, only to label it before Run (UX-SPEC §4.2). The worker's `sniffFormat` (the engine's)
 * is authoritative; this stays small so the engine's parsers are not part of the initial bundle.
 */
export type LightFormat = 'txt' | 'md' | 'html' | 'docx' | 'pdf' | 'unknown';

export function lightSniff(head: Uint8Array, name: string): LightFormat {
	if (head.length === 0) return 'unknown';
	const lower = name.toLowerCase();
	const ascii = (i: number) => head[i];
	if (ascii(0) === 0x25 && ascii(1) === 0x50 && ascii(2) === 0x44 && ascii(3) === 0x46)
		return 'pdf';
	if (ascii(0) === 0x50 && ascii(1) === 0x4b && ascii(2) === 0x03 && ascii(3) === 0x04)
		return /\.(docx|dotx|docm)$/.test(lower) ? 'docx' : 'unknown';
	let control = 0;
	const n = Math.min(head.length, 4096);
	for (let i = 0; i < n; i++) {
		const b = head[i] as number;
		if (b === 0) return 'unknown';
		if (b < 9 || (b > 13 && b < 32)) control++;
	}
	if (control / n > 0.02) return 'unknown';
	if (/\.(md|markdown|mdown|mkd)$/.test(lower)) return 'md';
	if (/\.(html?|xhtml)$/.test(lower)) return 'html';
	return 'txt';
}
